export default [
  {
    path: 'welcome-bonus/:currency?',
    name: 'welcome-bonus',
    component: () => import('pages/landingPages/WelcomeBonus.vue'),
  },
  {
    path: 'nezlob',
    name: 'nezlob',
    component: () => import('pages/landingPages/Nezlob'),
  },
  {
    path: 'new-year',
    name: 'new-year',
    component: () => import('pages/landingPages/NewYear/index.vue'),
  },
  {
    path: 'aviator',
    name: 'aviator',
    component: () => import('pages/landingPages/Aviator.vue'),
  },
  {
    path: 'gates_of_olympus/:currency?',
    name: 'gates_of_olympus',
    component: () => import('pages/landingPages/GatesOfOlympus.vue'),
  },
  {
    path: 'livecasino_wheel',
    name: 'livecasino_wheel',
    component: () => import('pages/landingPages/LivecasinoWheel.vue'),
  },
  {
    path: 'fruity_wheel',
    children: [
      {
        path: 'money/:currency?',
        name: 'fruity_wheel_money',
        component: () => import('pages/landingPages/FruityWheel.vue'),
      },
      {
        path: ':currency?',
        name: 'fruity_wheel',
        component: () => import('pages/landingPages/FruityWheel.vue'),
      },
    ],
  },
  {
    path: 'sweet_wheel/:currency?',
    name: 'sweet_wheel',
    component: () => import('pages/landingPages/SweetWheel.vue'),
  },
  {
    path: 'egypt_wheel',
    name: 'egypt_wheel',
    component: () => import('pages/landingPages/EgyptWheel.vue'),
  },
  {
    path: 'welcome_sport_1/:currency?',
    name: 'welcome_sport_1',
    meta: { content: 1 },
    component: () => import('pages/landingPages/WelcomeSport'),
  },
  {
    path: 'welcome_sport_2',
    name: 'welcome_sport_2',
    meta: { content: 2 },
    component: () => import('pages/landingPages/WelcomeSport'),
  },
  {
    path: 'welcome_sport_3',
    name: 'welcome_sport_3',
    meta: { content: 3 },
    component: () => import('pages/landingPages/WelcomeSport'),
  },
  {
    path: 'euro_2024',
    name: 'euro_2024',
    component: () => import('pages/landingPages/euro_2024'),
  },
  {
    path: 'euro_slots',
    name: 'euro_slots',
    component: () => import('pages/landingPages/EuroSlots'),
  },
  {
    path: 'golden_times_kz',
    name: 'golden_times_kz',
    component: () => import('pages/landingPages/GoldenTimesKz.vue'),
  },
  {
    path: 'mobile_app_setup',
    name: 'mobile_app_setup',
    component: () => import('pages/landingPages/MobileAppSetup.vue'),
  },
]
